module.exports = __webpack_public_path__ + "img/master.679e2666.png";